import { SIDEBAR_TOGGLE } from './actionTypes'

const initialState = {
    isOpen: false,
}

export const sidebarReducer = (state=initialState, action) => {
    switch (action.type) {
        case SIDEBAR_TOGGLE: 
            return {
                ...state,
                isOpen: (state.isOpen ? false : true),
            }
            
    
        default:
           return  state;
    }
}